const StandardButton = ({ children }) => {
  return children;
};
export {
  StandardButton
};
